/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */

/**
 * Allowed media type filter type values.
 */
export type MediaTypeFilterType = (typeof MediaTypeFilterType)[keyof typeof MediaTypeFilterType];

export const MediaTypeFilterType = {
  public: 'public',
  private: 'private',
} as const;
